var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "justify-content-end" },
    [
      _c(
        "b-col",
        { staticClass: "d-lg-block d-none", attrs: { cols: "12" } },
        [_vm._t("content")],
        2
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "auto" } },
        [
          _c(
            "b-dropdown",
            {
              staticClass: "d-lg-none d-flex",
              attrs: {
                dropleft: "",
                variant: "link",
                "toggle-class": "text-decoration-none text-black p-0",
                "no-caret": "",
                "menu-class": "overflow-visible",
              },
              scopedSlots: _vm._u([
                {
                  key: "button-content",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("more_vert"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_vm._v(" "), _vm._t("dropdown-content")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }